<template>
  <v-container v-if="ticketHistory.length" class="product-info__history">
    <v-row class="product-info__history-toggle-row">
      <v-col
        :id="
          showHistory
            ? 'product_tickets_history_hide'
            : 'product_tickets_history_show'
        "
        class="gtm-click product-info__history-toggle"
        @click="showHistory = !showHistory"
      >
        <div class="d-flex align-center">
          <h6 class="flex-grow-1 font-weight-medium text-primary py-1">
            {{ redeemedLabel }}
          </h6>

          <v-btn icon size="small" height="32" width="24">
            <template v-if="showHistory">
              <icon key="history-shown" height="12" primary>
                angle-up
              </icon>
            </template>
            <template v-if="!showHistory">
              <icon key="history-hidden" height="12" primary>
                angle-down
              </icon>
            </template>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="showHistory && hasActiveTickets">
      <v-col class="text-caption">
        <span>
          <icon class="me-1" height="16" width="16">info-circle</icon>
        </span>
        <span>
          Active tickets above are not shown in your history.
        </span>
      </v-col>
    </v-row>

    <v-row class="product-info__history-list-row">
      <v-col>
        <div v-if="showHistory" class="rounded-lg history">
          <v-list class="pb-0 bg-transparent elevation-0" flat>
            <template
              v-for="(orderProduct, idx) in ticketHistory"
              :key="orderProduct.id"
            >
              <v-divider
                v-if="idx > 0"
                class="opacity-50"
              ></v-divider>
              <ticket
                :itemsSelected="itemsSelected"
                :orderProduct="orderProduct"
                :product="product"
                v-bind="$attrs"
              />
            </template>
          </v-list>
        </div>
        <v-divider v-else class="opacity-50"></v-divider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment';
import Ticket from './Ticket.vue';

export default {
  name: 'TicketsHistory',
  inheritAttrs: false,
  props: {
    hasActiveTickets: Boolean,
    itemsSelected: {
      type: Array,
      default: () => []
    },
    product: {
      type: Object,
      default: () => ({})
    },
    productType: String
  },
  components: {
    Ticket
  },
  data() {
    return {
      showHistory: false
    };
  },
  computed: {
    redeemedLabel() {
      return `History (${this.ticketHistory.length})`;
    },

    redeemedTickets() {
      return this.sortedOrderProducts().filter(
        op => op.redeemed && (op.ticket?.timer || 1) <= 0
      );
    },

    showAllHistory() {
      // This would always show history when all products redeemed - off for now (maybe a setting?)
      return this.product.order_products.length === this.redeemedTickets.length;
    },

    ticketHistory() {
      return this.redeemedTickets.slice().sort((a, b) => {
        if (b.redeemed !== null) {
          return a.redeemed !== null
            ? moment(b.redeemed).diff(a.redeemed)
            : moment(b.redeemed).diff(a.end_date);
        }

        return a.redeemed !== null
          ? moment(b.end_date).diff(a.redeemed)
          : moment(b.end_date).diff(a.end_date);
      });
    }
  },
  methods: {
    sortedOrderProducts(sortBy = 'redeemed') {
      return this.product.order_products
        .slice()
        .sort(
          ({ [sortBy]: a }, { [sortBy]: b }) => (b === null) - (a === null)
        );
    }
  }
};
</script>

<style lang="scss">
.product-info__history{
  margin-bottom: 5px !important;
}
</style>
<style lang="scss" scoped>
.history {
  background-color: rgba(250, 250, 250, 1) !important;
  // transition: all 300ms ease-in;
  &.history-hidden {
    opacity: 0;
    height: 0;
    transition: none;
  }
  &.history-shown {
    opacity: 1;
    height: auto;
    transition: all 300ms ease-in;
  }
}

:deep(.product-info__history){
  margin-bottom: 4px;
}
:deep(.product-info__history-toggle-row .v-col) {
  padding: 8px 12px;
}

:deep(.product-info__history-list-row .v-col) {
  padding: 8px 12px;
}

// :deep(.product-info__history-toggle) {
//   padding-top: 4px !important;
// }
:deep(.v-row + .v-row) {
  margin-top: 0 !important;
}

:deep(.v-list) {
  padding: 0 !important;
}
</style>
